import { render, staticRenderFns } from "./AddCardiology.vue?vue&type=template&id=5e058a76&scoped=true"
import script from "./AddCardiology.vue?vue&type=script&lang=js"
export * from "./AddCardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e058a76",
  null
  
)

export default component.exports